import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "../../layout/main-layout/main-layout.component";
import {
	hasDoneTrainingSurvey,
	hasTrainingAccess,
} from "./guards/training.guard";

export default [
	{
		path: "training",
		component: MainLayoutComponent,
		canActivate: [hasTrainingAccess],
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./training.component").then((c) => c.TrainingComponent),
				canActivate: [hasDoneTrainingSurvey],
			},
			{
				path: "survey",
				loadComponent: () =>
					import("./training-survey/training-survey.component").then(
						(c) => c.TrainingSurveyComponent,
					),
			},
			{
				path: "recommendations",
				loadComponent: () =>
					import(
						"./training-recommendations/training-recommendations.component"
					).then((c) => c.TrainingRecommendationsComponent),
			},
		],
	},
] satisfies Routes;
